import { Constants } from '../helpers/constants';
import { Cookies } from '../helpers/cookies';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AppUrls } from 'src/app/helpers/app-urls';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject, firstValueFrom, empty, EMPTY } from 'rxjs';
import { Profile } from 'src/app/models/profile';
import { Roles } from '../models/Roles';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthServiceRefresher {
  apiUrl: string;
  email: string;
  phone: string;
  pass: string;

  constructor(
    private httpclient: HttpClient,
    private cookies: Cookies,
    private router: Router,
    private authService: AuthService
  ) {
    const urls = new AppUrls();
    this.apiUrl = urls.apiUrl;
  }

  authenticate() {
    // tslint:disable-next-line: max-line-length
    const urls = new AppUrls();
    this.apiUrl = urls.apiUrl;

    const constants = new Constants();
    const user = this.cookies.getCookie(constants.userDataName);

    this.phone = null;
    this.email = localStorage.getItem('email');
    this.pass = localStorage.getItem('password');

    // console.log(this.email);
    // console.log(this.pass);

    if (this.email == null || this.pass == null) {
      this.email = 'ranitesdefault@this.email.com';
      this.pass = 'ran';
      return EMPTY;
    }
    const url =
      this.apiUrl +
      '/api/user/auth/' +
      this.email +
      '/' +
      this.phone +
      '/' +
      this.pass +
      '/';
    return this.httpclient.get<any>(url).pipe(
      tap(
        // Log the result or error
        (error) => this.handleError
      )
    );
  }

  async refresherFunc() {
    const constants = new Constants();

    // validate usm user
    try {
      this.email = localStorage.getItem('email');
      this.pass = localStorage.getItem('password');
      await this.authService.getUser(this.email, this.pass);
    } catch (error) {
      console.log('ERROR', error);
    }

    const res = await firstValueFrom(this.authenticate())
      .catch((err) => this.handleError(err));
    if (res !== undefined && res !== null) {
      // // successful

      const user = new User();
      user.confCode = res.confCode;
      user.created = res.created;
      user.email = res.email;
      user.firstName = res.firstName;
      user.isEnabled = res.isEnabled;
      user.lastLogin = res.lastLogin;
      user.lastName = res.lastName;
      user.password = res.password;
      user.phone = res.phone;
      user.userId = res.userId;

      localStorage.setItem('usersessionid', res.userId);
      // store user data
      this.cookies.setCookie(constants.userDataName, user);

      // roles

      const userrole = new Roles();

      userrole.timeTrackingSection = false;
      userrole.timeTrackingExpert = false;
      userrole.timeLoggingSection = false;
      userrole.timeLoggingExpert = false;
      userrole.terminalSection = false;
      userrole.sessionSection = false;
      userrole.sessionExpert = false;
      userrole.checkPointSection = false;
      userrole.accountSection = false;
      userrole.accountExpert = false;
      userrole.statisticsSection = false;
      userrole.cardSection = false;
      userrole.cardExpert = false;
      userrole.personSection = false;
      userrole.personExpert = false;
      userrole.url = false;
      userrole.absenceExpert = false;

      userrole.calendarSection = false;
      userrole.calendarExpert = false;

      userrole.sessionTypeSection = false;
      userrole.sessionTypeExpert = false;

      userrole.configSection = false;
      userrole.configExpert = false;

      userrole.profileSection = false;
      userrole.profileExpert = false;

      userrole.complianceSection = false;
      userrole.complianceExpert = false;

      if (res.roles !== null && res.roles.length > 0) {
        for (const role of res.roles) {
          // checking time tracking roles
          if (
            role.role.roleParentType === 'time_tracking' &&
            role.role.roleName === 'Section'
          ) {
            userrole.timeTrackingSection = true;
          }

          if (
            role.role.roleParentType === 'time_tracking' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.timeTrackingExpert = true;
          }

          // checking time logging roles

          if (
            role.role.roleParentType === 'time_logging' &&
            role.role.roleName === 'Section'
          ) {
            userrole.timeLoggingSection = true;
          }

          if (
            role.role.roleParentType === 'time_logging' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.timeLoggingExpert = true;
          }

          // checking terminal roles

          if (
            role.role.roleParentType === 'terminal' &&
            role.role.roleName === 'Section'
          ) {
            userrole.terminalSection = true;
          }

          // checking session roles
          if (
            role.role.roleParentType === 'session' &&
            role.role.roleName === 'Section'
          ) {
            userrole.sessionSection = true;
          }
          if (
            role.role.roleParentType === 'session' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.sessionExpert = true;
          }

          // checking checkpoint roles
          if (
            role.role.roleParentType === 'checkpoint' &&
            role.role.roleName === 'Section'
          ) {
            userrole.checkPointSection = true;
          }

          // account roles
          if (
            role.role.roleParentType === 'account' &&
            role.role.roleName === 'Section'
          ) {
            userrole.accountSection = true;
          }

          if (
            role.role.roleParentType === 'account' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.accountExpert = true;
          }

          // statistics role
          if (
            role.role.roleParentType === 'statistics' &&
            role.role.roleName === 'Section'
          ) {
            userrole.statisticsSection = true;
          }

          // card permission
          if (
            role.role.roleParentType === 'card' &&
            role.role.roleName === 'Section'
          ) {
            userrole.cardSection = true;
          }

          if (
            role.role.roleParentType === 'card' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.cardExpert = true;
          }

          // person permission
          if (
            role.role.roleParentType === 'person' &&
            role.role.roleName === 'Section'
          ) {
            userrole.personSection = true;
          }

          if (
            role.role.roleParentType === 'person' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.personExpert = true;
          }

          // url permission
          if (
            role.role.roleParentType === 'url' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.url = true;
          }

          // absence permission
          if (
            role.role.roleParentType === 'absence' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.absenceExpert = true;
          }

          // calendar permission
          if (
            role.role.roleParentType === 'calendar' &&
            role.role.roleName === 'Section'
          ) {
            userrole.calendarSection = true;
          }

          if (
            role.role.roleParentType === 'calendar' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.calendarExpert = true;
          }

          // session type permission
          if (
            role.role.roleParentType === 'sessiontype' &&
            role.role.roleName === 'Section'
          ) {
            userrole.sessionTypeSection = true;
          }

          if (
            role.role.roleParentType === 'sessiontype' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.sessionTypeExpert = true;
          }

          // config permission
          if (
            role.role.roleParentType === 'config' &&
            role.role.roleName === 'Section'
          ) {
            userrole.configSection = true;
          }

          if (
            role.role.roleParentType === 'config' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.configExpert = true;
          }

          // profile permission
          if (
            role.role.roleParentType === 'profile' &&
            role.role.roleName === 'Section'
          ) {
            userrole.profileSection = true;
          }

          if (
            role.role.roleParentType === 'profile' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.profileExpert = true;
          }

          if (
            role.role.roleParentType === 'config' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.configExpert = true;
          }

          // compliance permission
          if (
            role.role.roleParentType === 'compliance' &&
            role.role.roleName === 'Section'
          ) {
            userrole.complianceSection = true;
          }

          if (
            role.role.roleParentType === 'compliance' &&
            role.role.roleName === 'Expert'
          ) {
            userrole.complianceExpert = true;
          }

        }

      localStorage.setItem(
        'usersessionname',
        res.firstName + ' ' + res.lastName
      );

      localStorage.setItem('userId', res.userId);

      localStorage.setItem(
        'usersessionname',
        res.firstName + ' ' + res.lastName
      );

      localStorage.setItem('userId', res.userId);

      localStorage.setItem('organisationId', res.organisationId);

      userrole.firstName=res.firstName;
      userrole.lastName=res.lastName;
      }


      this.pokeRoles(userrole);

      // store user roles

      this.cookies.setCookie(constants.cookieRolesName, userrole);

      // store cookie data
      this.cookies.setCookie(constants.cookieDataName, 'true');



    }
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  userroles$ = new BehaviorSubject<Roles | null>(null);

  // eslint-disable-next-line @typescript-eslint/member-ordering
  profile$ = new BehaviorSubject<Profile | null>(null);

  watchProfile(): Observable<Profile | null> {
    return this.profile$;
  }
  peekProfile(): Profile | null {
    return this.profile$.value;
  }
  pokeProfile(profile: Profile): void {
    this.profile$.next(profile);
  }

  watchUserRoles(): Observable<Roles | null> {
    return this.userroles$;
  }
  peekRoles(): Roles | null {
    return this.userroles$.value;
  }

  pokeRoles(role: Roles): void {
    this.userroles$.next(role);
  }

  private handleError(error: any) {
    throw error;
    return error;
  }
}

export class User {
  confCode: string;
  created: string;
  email: string;
  firstName: string;
  isEnabled: string;
  lastLogin: string;
  lastName: string;
  password: string;
  phone: string;
  userId: string;
  roles: any;
}
